import { DEFAULT_BRAND_KEY, isBrandKey } from '../../config/brands';
import { BRAND_PROFILES } from '../../config/brandProfiles';

/**
 * Brand marker for an admin list row.
 *
 * Deliberately NOT the parent portal's `BrandBadge`, which renders nothing outside
 * `BrandProfileProvider` — and the admin portal routes above it. An admin still has to be able
 * to see which brand a program, invoice or payment belongs to.
 *
 * Renders nothing for the default brand unless `showDefault` is set, so a single-brand list is
 * unchanged and the marker stays the exception that draws the eye.
 */
export function AdminBrandTag({ brand, showDefault = false }: { brand?: string | null; showDefault?: boolean }) {
  const key = isBrandKey(brand) ? brand : DEFAULT_BRAND_KEY;
  if (key === DEFAULT_BRAND_KEY && !showDefault) return null;
  const profile = BRAND_PROFILES[key];
  return (
    <span
      className="inline-flex items-center rounded-full border px-1.5 py-0 text-[10px] font-medium whitespace-nowrap"
      style={{ borderColor: profile.accent, backgroundColor: profile.accentSoft, color: profile.accentInk }}
    >
      {profile.shortName}
    </span>
  );
}
